<app-menu-common url="stock"></app-menu-common>
<p>stock-home works!</p>
